function _getToday () {
  const today = new Date();

  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);

  return today;
}

export const getToday = () => {
  return _getToday();
};

export const getYesterday = () => {
  const t = _getToday();
  t.setTime(t.getTime() - 24 * 60 * 60 * 1000);
  return t;
};

export const getDaysAgo = (days = 0) => {
  const t = _getToday();
  t.setTime(t.getTime() - days * 24 * 60 * 60 * 1000);
  return t;
};

export const get7DaysAgo = () => {
  const t = _getToday();
  t.setTime(t.getTime() - 7 * 24 * 60 * 60 * 1000);
  return t;
};

export const getWeeksAgo = (weeks = 1) => {
  const t = _getToday();
  t.setTime(t.getTime() - 7 * weeks * 24 * 60 * 60 * 1000);
  return t;
};

export const get30DaysAgo = () => {
  const t = _getToday();
  t.setTime(t.getTime() - 30 * 24 * 60 * 60 * 1000);
  return t;
};

export const getYearsAgo = (years = 1) => {
  const t = _getToday();
  t.setFullYear(t.getFullYear() - years);
  return t;
};

export const getThisWeekStart = () => {
  const t = _getToday();
  const day = t.getDay();
  if (day === 0) {
    t.setTime(t.getTime() - 6 * 24 * 60 * 60 * 1000);    // 6 days ago
  } else if (day > 1) {                                 // day 1 === Monday
    t.setTime(t.getTime() - (day - 1) * 24 * 60 * 60 * 1000);
  }
  return t;
};

export const getThisWeekEnd = () => {
  const t = getToday();
  const day = t.getDay();
  if (day > 0) {                                 // day 0 === Sunday
    t.setTime(t.getTime() + (7 - day) * 24 * 60 * 60 * 1000);
  }
  return t;
};

export const getWeeksAgoStart = (weeks = 1) => {
  const t = _getToday();
  t.setTime(t.getTime() - 7 * weeks * 24 * 60 * 60 * 1000);
  const day = t.getDay();
  if (day === 0) {
    t.setTime(t.getTime() - 6 * 24 * 60 * 60 * 1000);     // 6 days ago
  } else if (day > 1) {                                   // day 1 === Monday
    t.setTime(t.getTime() - (day - 1) * 24 * 60 * 60 * 1000);
  }
  return t;
};

export const getWeeksAgoEnd = (weeks = 1) => {
  const t = _getToday();
  t.setTime(t.getTime() - 7 * weeks * 24 * 60 * 60 * 1000);
  const day = t.getDay();
  if (day > 0) {                                 // day 0 === Sunday
    t.setTime(t.getTime() + (7 - day) * 24 * 60 * 60 * 1000);
  }
  return t;
};

export const getThisMonthStart = () => {
  const t = getToday();
  t.setDate(1);
  return t;
};

export const getThisMonthEnd = () => {
  const t = getToday();
  t.setMonth(t.getMonth() + 1);
  t.setDate(0);       // Date 0 === last day of the last month
  return t;
};

export const monthFormatter = (date) => {
  if (date instanceof Date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;

    return `${year}-${month}`;
  } else if (typeof date === 'undefined') {
    return '';
  } else {
    return date;
  }
};

export const dateFormatter = (date) => {
  if (date instanceof Date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let day = date.getDate();
    if (day < 10) day = '0' + day;

    return `${year}-${month}-${day}`;
  } else if (typeof date === 'undefined') {
    return '';
  } else {
    return date;
  }
};

export const datetimeFormatter = (date) => {
  if (date instanceof Date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let day = date.getDate();
    if (day < 10) day = '0' + day;

    let hour = date.getHours();
    if (hour < 10) hour = '0' + hour;
    let minute = date.getMinutes();
    if (minute < 10) minute = '0' + minute;
    let second = date.getSeconds();
    if (second < 10) second = '0' + second;

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  } else if (typeof date === 'undefined') {
    return '';
  } else {
    return date;
  }
};
